import { createFileRoute, redirect } from "@tanstack/react-router";
import { getAppConfig } from "../config/config";
import { MainLayoutView } from "../views/app/layout/main-layout-view";

export const Route = createFileRoute("/_main")({
  beforeLoad: async ({ context }) => {
    const { refetch } = context.authentication;
    const loginURL = `${getAppConfig().env.gatewayUrl}/oauth2/authorization/keycloak`;

    await refetch().then(
      (response) => {
        if (!response.data)
          throw redirect({
            to: loginURL,
          });
      },
      () => {
        throw redirect({
          to: loginURL,
        });
      }
    );
  },
  component: MainLayoutView,
});
